export const TOOLTIP_OFFSET = 4;
export const TOOLTIP_SIDES_OFFSET = 4 * TOOLTIP_OFFSET;
